"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _components = require("@engaging-tech/components");
var _routing = require("@engaging-tech/routing");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useNavContext2 = _interopRequireDefault(require("../../hooks/useNavContext"));
var _Drawer = _interopRequireDefault(require("./Drawer"));
var _OffAxisButton = _interopRequireDefault(require("./OffAxisButton"));
var StickyWrapper = (0, _styledComponents["default"])(_components.TabletDown).withConfig({
  displayName: "Navbar__StickyWrapper",
  componentId: "sc-zfj1ou-0"
})(["position:sticky;top:0;width:100%;background:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.light[0];
});
var MovedFlexed = (0, _styledComponents["default"])(_components.Flex).withConfig({
  displayName: "Navbar__MovedFlexed",
  componentId: "sc-zfj1ou-1"
})(["position:absolute;width:auto;left:16px;top:16px;"]);
var LogoFlex = (0, _styledComponents["default"])(_components.Flex).withConfig({
  displayName: "Navbar__LogoFlex",
  componentId: "sc-zfj1ou-2"
})(["position:relative;width:auto;"]);
var ClickableIcon = (0, _styledComponents["default"])(_components.Icon).withConfig({
  displayName: "Navbar__ClickableIcon",
  componentId: "sc-zfj1ou-3"
})(["&:hover{cursor:pointer;}"]);
var Image = _styledComponents["default"].img.withConfig({
  displayName: "Navbar__Image",
  componentId: "sc-zfj1ou-4"
})(["max-width:250px;max-height:50px;margin-left:15px;margin-right:15px;"]);

/**
 * The main desktop navbar.
 * @param {object} props React components passed in props
 * @param {function} props.siteLogo The site's logo. Shown on the top left
 * of the Navbar.
 * @package
 */
var Navbar = function Navbar(_ref2) {
  var SiteLogo = _ref2.siteLogo,
    linkTo = _ref2.linkTo;
  var _useNavContext = (0, _useNavContext2["default"])(),
    toggleDrawer = _useNavContext.toggleDrawer,
    zIndex = _useNavContext.zIndex,
    elevation = _useNavContext.elevation,
    mobileNavbarHeight = _useNavContext.mobileNavbarHeight,
    headerLogo = _useNavContext.headerLogo;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StickyWrapper, {
    style: {
      zIndex: zIndex
    }
  }, /*#__PURE__*/_react["default"].createElement(_components.Flex, {
    as: "nav",
    justifyContent: "center",
    py: 2,
    px: 3,
    elevation: elevation,
    alignItems: "center",
    height: mobileNavbarHeight
  }, /*#__PURE__*/_react["default"].createElement(MovedFlexed, null, /*#__PURE__*/_react["default"].createElement(ClickableIcon, {
    name: "menu",
    mr: 3,
    onClick: toggleDrawer,
    color: "dark.2"
  })), !headerLogo && SiteLogo && /*#__PURE__*/_react["default"].createElement(LogoFlex, null, /*#__PURE__*/_react["default"].createElement(_routing.Link, {
    to: linkTo || "/"
  }, /*#__PURE__*/_react["default"].createElement(SiteLogo, null))), headerLogo && /*#__PURE__*/_react["default"].createElement(Image, {
    src: headerLogo,
    alt: "Your company logo"
  }), /*#__PURE__*/_react["default"].createElement(_OffAxisButton["default"], null)), /*#__PURE__*/_react["default"].createElement(_Drawer["default"], {
    siteLogo: SiteLogo,
    linkTo: linkTo
  })));
};
var _default = exports["default"] = Navbar;